import { ca } from '@cian/analytics';
import {
  ICreateCianAnalyticsPageViewObjectParams,
  createCianAnalyticsPageViewObject,
} from './createCianAnalyticsPageViewObject';

export const trackPageView = (params: ICreateCianAnalyticsPageViewObjectParams) => {
  // oxlint-disable-next-line typescript/no-explicit-any
  ca('pageviewSite', createCianAnalyticsPageViewObject(params) as any);
};
